var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487.43 434.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#82c48c;}.cls-2{fill:#6dc77a;}.cls-3{fill:#25252d;}.cls-4{fill:#373635;}.cls-5{fill:#21201f;}.cls-5,.cls-8{opacity:0.5;}.cls-6,.cls-8{fill:#fff;}.cls-7{fill:#e1e4fe;}.cls-9{fill:#cdcdcf;}.cls-10{fill:#b7b7b7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 103") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.83,379.8H275a0,0,0,0,1,0,0v49.35a.72.72,0,0,1-.72.72H216.55a.72.72,0,0,1-.72-.72V379.8A0,0,0,0,1,215.83,379.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 215.83,
    y: 391.11,
    width: 59.21,
    height: 10.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.05,433.9a4.5,4.5,0,0,1-4.5-4.5V384.48H220.33V429.4a4.5,4.5,0,0,1-9,0V375.48h68.22V429.4A4.51,4.51,0,0,1,275.05,433.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.19,
    y: 425.54,
    width: 92.82,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 175.74,
    y: 425.54,
    width: 11,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 304.48,
    y: 425.54,
    width: 12.69,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.95,
    y: 46,
    width: 474.98,
    height: 340.67,
    rx: 29.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.84,384.21c-.76.07-1.53.1-2.3.1H39.91a29.67,29.67,0,0,1-29.68-29.67L7,68.54C7,51.53,24.34,46.93,24.44,46,50.73,56.71,45,84.08,59.5,102.71c19,24.3,2.79,75.05-2.57,101.42-8.15,40.13-21.63,82.8-19.46,124.15C40,376,102.23,385.16,140,387.88c49.88,3.58,100.12,1.5,149.73-3.14C344.05,379.67,405.32,389.69,457.84,384.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 41.3,
    y: 75.04,
    width: 408.28,
    height: 247.59
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "449.58 75.04 41.3 75.04 41.3 92.54 88.53 92.54 88.53 322.63 106.03 322.63 106.03 92.54 449.58 92.54 449.58 75.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.54,391.17H32.34A28.92,28.92,0,0,1,3.45,362.28V70.39A28.92,28.92,0,0,1,32.34,41.5h426.2a28.92,28.92,0,0,1,28.89,28.89V362.28A28.92,28.92,0,0,1,458.54,391.17ZM32.34,50.5A19.91,19.91,0,0,0,12.45,70.39V362.28a19.92,19.92,0,0,0,19.89,19.89h426.2a19.92,19.92,0,0,0,19.89-19.89V70.39A19.91,19.91,0,0,0,458.54,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.44,172.59a2.5,2.5,0,0,1-2.5-2.5V109.62a2.5,2.5,0,0,1,5,0v60.47A2.5,2.5,0,0,1,245.44,172.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.44,201.94a2.49,2.49,0,0,1-2.5-2.5v-12.7a2.5,2.5,0,0,1,5,0v12.7A2.49,2.49,0,0,1,245.44,201.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.44,220.55a2.5,2.5,0,0,1-2.5-2.5v-3.71a2.5,2.5,0,1,1,5,0v3.71A2.5,2.5,0,0,1,245.44,220.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 462.97,
    y: 137.14,
    width: 7,
    height: 60.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 462.8,
    y: 206.66,
    width: 7,
    height: 18.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.53,159.79a2.5,2.5,0,0,1-2.5-2.5V96.82a2.5,2.5,0,0,1,5,0v60.47A2.5,2.5,0,0,1,245.53,159.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.35,180a2.5,2.5,0,0,1-2.5-2.5v-8.12a2.5,2.5,0,0,1,5,0v8.12A2.5,2.5,0,0,1,245.35,180Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.39,321.27H126.18A18.28,18.28,0,0,1,107.9,303l-.68-278.49A18.27,18.27,0,0,1,125.49,6.23H364.7A18.28,18.28,0,0,1,383,24.46L383.66,303A18.27,18.27,0,0,1,365.39,321.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "384.72 318.67 108.96 318.67 108.19 306.2 383.94 306.2 384.72 318.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.52,325.77a4.5,4.5,0,0,1-4.5-4.49l-.74-300.94a9.64,9.64,0,0,0-9.63-9.61H120.16a9.63,9.63,0,0,0-9.63,9.66l.74,300.87a4.51,4.51,0,0,1-4.49,4.51h0a4.5,4.5,0,0,1-4.5-4.49l-.74-300.87A18.64,18.64,0,0,1,120.16,1.73H367.65a18.66,18.66,0,0,1,18.63,18.59L387,321.26a4.49,4.49,0,0,1-4.48,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454.08,327.12H36.8V70.54h68.37a4.5,4.5,0,0,1,0,9H45.8V318.12H445.08V79.54h-62a4.5,4.5,0,0,1,0-9h71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 246.45,
    cy: 351.21,
    r: 9.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.45,363.36a12.15,12.15,0,1,1,12.15-12.15A12.16,12.16,0,0,1,246.45,363.36Zm0-18.3a6.15,6.15,0,1,0,4.61,2.08A6.16,6.16,0,0,0,246.45,345.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 319.4,
    y: 83.55,
    width: 7,
    height: 24.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 319.31,
    y: 116.39,
    width: 7,
    height: 11.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 240.82,
    y: 81.13,
    width: 7,
    height: 24.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 240.73,
    y: 113.96,
    width: 7,
    height: 11.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 395.29,
    y: 338.65,
    width: 55.47,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 373.12,
    y: 338.48,
    width: 11.12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 157.52,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 182.41,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 207.34,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 232.26,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 384.72,
    y: 92.54,
    width: 17.1,
    height: 228.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 181.34,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 206.27,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 231.19,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.12,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.75,
    y: 346.71,
    width: 88.59,
    height: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-9",
    d: "M308.27,170.5c0-2.53.84-5.06.84-8.43s0-5.9-.84-8.42L326,139.32a4,4,0,0,0,.85-5L310,104.78a4.72,4.72,0,0,0-5.06-.85l-21.07,8.43c-4.21-3.37-9.26-5.9-14.32-8.43L266.14,82c.84-2.52-1.69-4.21-3.37-4.21H229.06c-1.68,0-4.21,1.69-4.21,3.37l-3.37,22.75c-5,1.69-9.27,5.06-14.32,8.43l-20.23-8.43c-2.52-.84-4.21,0-5.89,1.69l-16.86,29.49c-.84.84,0,3.37,1.69,5l17.69,13.49c0,2.52-.84,5-.84,8.42s0,5.9.84,8.43l-17.69,14.32a4,4,0,0,0-.84,5.06l16.85,29.49a4.71,4.71,0,0,0,5.05.84L208,211.79c4.21,3.37,9.27,5.9,14.32,8.42l3.37,21.91c0,1.69,1.69,3.37,4.22,3.37h33.7c1.69,0,4.21-1.68,4.21-3.37l3.38-21.91c5.05-2.52,10.11-5.05,14.32-8.42l21.06,8.42a4.05,4.05,0,0,0,5.06-1.68L328.49,189c.85-1.69.85-4.22-.84-5.06L308.27,170.5Zm-62.35,21.06a29.49,29.49,0,1,1,29.49-29.49,29.85,29.85,0,0,1-29.49,29.49Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328.49,190.15l-16.86,29.49a4,4,0,0,1-5.05,1.68l-21.07-8.41c-4.19,3.37-9.27,5.9-14.32,8.41l-3.36,21.94c0,1.68-2.54,3.36-4.22,3.36H229.9c-2.51,0-4.2-1.68-4.2-3.36l-2.39-15.47A100.46,100.46,0,0,0,299.91,107l5-2c2.54-.85,4.22,0,5.05.86L326.8,135.4a3.93,3.93,0,0,1-.82,5l-17.71,14.32c.85,2.54.85,5.08.85,8.44s-.85,5.91-.85,8.42l19.39,13.49C329.34,185.93,329.34,188.47,328.49,190.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-2",
    "data-name": "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-2",
    "data-name": "Core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-2",
    "data-name": "settings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.61,250h-33.7c-4.65,0-8.46-3.3-8.7-7.44l-3-19.36a84.52,84.52,0,0,1-10.91-6.29l-19,7.58a9.22,9.22,0,0,1-9.66-1.93l-.43-.42-4.75-8.31,7.82-4.47,3.82,6.69.25-.06,23.35-9.35,2.05,1.64c3.84,3.07,8.54,5.42,13.51,7.91l2.09,1,.36,2.31,3.3,21.46h33.32l.06,0,3.65-23.73,2.08-1c5-2.5,9.69-4.85,13.53-7.92l2.05-1.64L308,215.91l16.42-28.73-21.85-15.24,2.12-4.13a12.46,12.46,0,0,0-.27-11.92l-1.91-3.33,20.25-16.39-16-28.06-.26.06-23.35,9.34L281,115.87c-3.84-3.07-8.54-5.42-13.52-7.91l-2.08-1-3.79-24.61H229.29l-.06,0-3.7,25-2.63.87c-3.41,1.14-6.55,3.3-10.18,5.81-1,.69-2,1.39-3.07,2.09l-2,1.34-22.26-9.28a.89.89,0,0,0-.33-.06,3.1,3.1,0,0,0-.45.33l-16,28a4.61,4.61,0,0,0,.28.38L189,152.15l-1.3,3.19c0,.06-2.84,7.31-.08,13.27l1.47,3.18-20,16.19,4.58,8-7.81,4.47L161,191.89a8.45,8.45,0,0,1,1.69-10.25l.35-.31L178.26,169a28.14,28.14,0,0,1,.09-13.68l-15.66-12a12.11,12.11,0,0,1-2.88-4.61,6.63,6.63,0,0,1,.65-6.18l17-29.7.42-.43a9.72,9.72,0,0,1,10.51-2.77l.31.12,18,7.49,1-.67a61.05,61.05,0,0,1,9.8-5.91l3-19.94c.29-4.22,4.8-7.44,8.69-7.44h33.71a8.45,8.45,0,0,1,6.64,3.45,7.3,7.3,0,0,1,1.31,5.42L273.6,101a85.7,85.7,0,0,1,10.91,6.29l19-7.58a9.22,9.22,0,0,1,9.66,1.93l.42.43,17.27,30.23a8.45,8.45,0,0,1-1.68,10.25l-.35.32L313.8,155a21.34,21.34,0,0,1,.11,14L330,180.15c3.82,2.19,4.3,7.29,2.5,10.9l-.12.22-16.81,29.41a8.25,8.25,0,0,1-4.74,3.91,8.34,8.34,0,0,1-6.07-.25L286.2,216.9a85.2,85.2,0,0,1-10.91,6.29l-3,19.38C272,246.78,267.5,250,263.61,250Zm-17.69-53.93c-18.43,0-34-15.56-34-34s15.56-34,34-34,34,15.57,34,34S264.34,196.06,245.92,196.06Zm0-59a25,25,0,1,0,25,25A25.33,25.33,0,0,0,245.92,137.08Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.69,157.67l-7-.29c0-.3,1.53-30.61,29.32-38.84l2,6.71C204.08,132,202.74,156.62,202.69,157.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c9b9d728d71a3e4af42c9ab60823019a.svg";
export { ForwardRef as ReactComponent };